import { rgbToHex } from '@mui/material';

/** Fallback for `<input type="color" />` — empty or invalid values break the DOM constraint. */
export const COLOR_INPUT_DEFAULT = '#000000';

/** Returns a string always valid for `type="color"` (`#` + six hex digits). */
export function toColorInputValue(color: string | null | undefined): string {
  const raw = (color ?? '').trim();
  if (!raw) return COLOR_INPUT_DEFAULT;
  try {
    const normalized = convertHexTo6(raw);
    if (typeof normalized === 'string' && /^#[0-9A-Fa-f]{6}$/.test(normalized)) {
      return normalized.toLowerCase();
    }
  } catch {
    // rgbToHex / parsing can throw on bad input
  }
  return COLOR_INPUT_DEFAULT;
}

export const convertHexTo6 = (color: string) => {
  if (!color.startsWith("#")) {
    color = rgbToHex(color);
  }

  if (color.startsWith("#") && color.length === 4) {
    const colorCode = (color as string).replace("#", "");

    const colorArr: string[] = [];
    colorCode.split("").forEach((c) => colorArr.push(c, c));

    color = `#${colorArr.join("")}`;
  }
  return color;
};

let timeout: any;

export const debounce = (fn: (...args: any) => any, wait = 200) => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(fn, wait);
};
